var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 236 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 236,
    height: 236,
    fill: "#2476F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 143.623L47.448 132.352C50.971 140.523 57.029 146.015 68.1635 146.015C79.298 146.015 81.547 141.79 81.547 137.988C81.547 131.93 75.9115 129.531 61.1175 125.449C46.46 121.361 32.095 114.315 32.095 95.4389C32.095 76.5629 48.15 65.4219 65.1995 65.4219C82.249 65.4219 94.0855 73.1699 101.268 87.6844L82.2425 98.8189C78.8625 91.7729 74.215 87.4049 65.193 87.4049C58.147 87.4049 54.624 90.9279 54.624 94.8734C54.624 99.3844 57.0225 102.485 72.3755 107.132C87.3125 111.643 104.076 116.856 104.076 137.708C104.076 156.727 88.8595 168.005 67.442 168.005C46.0245 168.005 33.4925 158.131 28 143.623Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M189.857 102.819C189.857 121.559 174.777 136.639 155.336 136.639H140.542V145.095C140.542 157.543 130.447 167.637 118 167.637V69H155.336C174.784 69 189.857 84.08 189.857 102.819ZM167.309 102.819C167.309 95.637 162.239 90.138 155.329 90.138H140.535V115.501H155.329C162.239 115.501 167.309 110.002 167.309 102.819Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M220.883 141.422H195V167.305H220.883V141.422Z",
    fill: "#ED544F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cceb752d7bbe23da93f9df33a27fb89c.svg";
export { ForwardRef as ReactComponent };